import React, { FC, ReactNode, useEffect } from 'react';
import styles from './DeliveryDashboard.module.scss';
import DeliveryDashboardMap from './components/DeliveryDashboardMap';
import { APIProvider } from '@vis.gl/react-google-maps';
import DashboardOnboarding from './components/DashboardOnboarding';
import { useOnboardingStore } from '@src/shared/store/onboarding/onboarding-store';
import { DashboardOnboardingTutorialReminder } from './components/DashboardOnboarding/components/DashboardOnboardingTutorialReminder';
import usePageVisibilityChange from '@src/shared/hooks/use-page-visibility-change';
import useDeviceDetect from '@src/shared/hooks/use-device-detect';

interface IDeliveryDashboardProps {
  children?: ReactNode;
}

export const DeliveryDashboard: FC<IDeliveryDashboardProps> = () => {
  const { onboardingActive } = useOnboardingStore();
  const { isPageVisiblityChanged } = usePageVisibilityChange();
  const { isResolutionMobile } = useDeviceDetect();

  useEffect(() => {
    if (isPageVisiblityChanged && isResolutionMobile && location.pathname !== '/couriers') {
      location.reload();
    }
  }, [isPageVisiblityChanged]);

  return (
    <div className={styles.container}>
      <APIProvider
        apiKey={process.env.GOOGLE_MAPS_API_KEY as string}
        libraries={['marker', 'routes']}
      >
        {onboardingActive ? <DashboardOnboarding /> : <DeliveryDashboardMap />}
        <DashboardOnboardingTutorialReminder />
      </APIProvider>
    </div>
  );
};

export default DeliveryDashboard;
